import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { PersonOffDayService } from 'src/app/Service/Person/PersonOffDay.service';

@Component({
  selector: 'app-PersonOffDayAdd',
  templateUrl: './PersonOffDayAdd.component.html',
  styleUrls: ['./PersonOffDayAdd.component.scss']
})
export class PersonOffDayAddComponent implements OnInit {

  Token: String = ""

  constructor(
    private PersonOff_Service: PersonOffDayService,
    private Person_Service: PersonService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.AddNewOffday = new FormGroup({
      id: new FormControl(),
      endDate: new FormControl(),
      startDate: new FormControl(),
      dsc: new FormControl(null, Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token, 2195).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewOffday: FormGroup;

  get_Form_endDate() {
    return this.AddNewOffday.get('endDate') as FormControl;
  }

  get_Form_startDate() {
    return this.AddNewOffday.get('startDate') as FormControl;
  }

  get_Form_dsc() {
    return this.AddNewOffday.get('dsc') as FormControl;
  }

  //#endregion



  //#region  Person

  modalRef_Person: any;
  page: number = 0

  ProcssingPerson: boolean = false

  Search_Name_Person_Table: string = ''

  openModal_Person(template: TemplateRef<any>) {
    this.modalRef_Person = this.modalService.show(template);
  }

  DataList_Person: Array<Persone_List_Interface> = []
  Data_Seleted_Record: Persone_List_Interface = Empty_Persone_List_Interface()



  ReadData_Person() {
    this.ProcssingPerson = true
    this.Person_Service.GetActive(this.Token).subscribe(
      data => {
        this.DataList_Person = data
        this.ProcssingPerson = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Set_Selected_Person_Record(item) {
    this.Data_Seleted_Record = item
    this.modalRef_Person.hide()
  }

  //#endregion






  InProccessing: boolean = false
  Switcher_form: string = 'Insert'

  startDate_fulldate: string = ''
  endDate_fulldate: string = ''
  off: number = 0
  on: number = 0

  CheckOffday() {

    if (this.Data_Seleted_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("Select a substitute.")
    }
    else{
    this.InProccessing = true
    this.PersonOff_Service.CheckOffday(
      this.get_Form_startDate().value,
      this.get_Form_endDate().value,
      this.get_Form_dsc().value,
      this.Token).subscribe(
        data => {
          this.InProccessing = false
          this.set_Switcher_form("Check")

          this.startDate_fulldate = data['startDate_fulldate']
          this.endDate_fulldate = data['endDate_fulldate']
          this.off = data['off']
          this.on = data['on']
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  set_Switcher_form(item: string) {
    this.Switcher_form = item
  }

  SubmitAddNewOffday() {
    this.InProccessing = true
    this.PersonOff_Service.AddOffday(
      this.get_Form_startDate().value,
      this.get_Form_endDate().value,
      this.get_Form_dsc().value,
      this.Data_Seleted_Record.id,
      this.Token).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("You already have a request for this time range.")
          }
          else if (data.id == -6) {
            this.Alertify_Service.ErrorMessage("The substitute already has a request for this time range.")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("The leave period contains no working day.")
          }
          else if (data.id == -3) {
            this.Alertify_Service.ErrorMessage("No active workflow has been selected for daily leave.")
          }
          else if (data.id == -4) {
            this.Alertify_Service.ErrorMessage("System error.")
          }
          else if (data.id == -5) {
            this.Alertify_Service.ErrorMessage("You do not have a position in the organizational chart.")
          }
          else {
            this.Data_Seleted_Record=Empty_Persone_List_Interface()
            this.AddNewOffday.reset()
            this.set_Switcher_form('Insert')
            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }

}
